const roles: Record<string, string> = { buyer: "Client", provider: "Provider", employer: "Employer", worker: "Worker" };
export const workInitials = (name: string | null) => name?.trim().split(/\s+/).slice(0, 2).map(part => part.charAt(0)).join("").toUpperCase() || "?";
export const workTime = (value: string) => new Date(value).toLocaleString("en-PH", { timeZone: "Asia/Manila", dateStyle: "medium", timeStyle: "short" }) + " PHT";

export function WorkAttribution({ name, role, companyId, at }: { name: string | null; role: string; companyId: string | null; at: string }) {
  return <div className="wu-report-top">
    <div aria-hidden="true" className={`wu-avatar ${role === "buyer" || role === "employer" ? "wu-avatar-buyer" : ""}`}>{workInitials(name)}</div>
    <div className="min-w-0"><strong>{name || "Unknown author"}</strong><span>{roles[role] || "Unknown role"} · {companyId ? "Business profile" : "Personal"}</span></div>
    <time dateTime={at}>{workTime(at)}</time>
  </div>;
}
